import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { ChartDataPoint } from './types';

const DEFAULT_COLOR = '#6366f1';

interface BarChartProps {
  data: ChartDataPoint[];
  color?: string;
}

/**
 * Vertical bar chart backed by Recharts. Fills its parent container via `ResponsiveContainer`.
 *
 * @example
 * <BarChart
 *   data={[{ name: 'Jan', value: 42 }, { name: 'Feb', value: 58 }]}
 *   color="#6366f1"
 * />
 */
export function BarChart({ data, color = DEFAULT_COLOR }: BarChartProps) {
  const chartData = data.map((d) => ({ name: d.name, value: d.value }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RechartsBarChart data={chartData} margin={{ top: 4, right: 8, left: 0, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="currentColor" strokeOpacity={0.1} />
        <XAxis dataKey="name" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
        <YAxis tick={{ fontSize: 11 }} tickLine={false} axisLine={false} width={36} />
        <Tooltip
          formatter={(value) =>
            typeof value === 'number' ? value.toLocaleString() : String(value ?? '')
          }
        />
        <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} />
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
